 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"6c3301841966121d31ad3c402bc9f3ef6743708e","2":"a9a7754c","3":"c8448dc6fc1b73ed4655efbb68909e3bece9f249","4":"862906f15f3a45f165700e3a493a94f3528a0196","5":"styles","6":"0d28399fbb6fd230bc338b1270c6c3ab5e783c73","7":"31a89dfe27eda9d85a878493d0bca4d19294b91e","8":"368aecf4240697ddeb2db28fc8549b6e0d88c98f","10":"1c8efbdd","12":"cb1608f2","13":"component---src-pages-404-js","14":"component---src-pages-about-js","15":"component---src-pages-admin-js","16":"component---src-pages-blogs-js","17":"component---src-pages-books-js","18":"component---src-pages-contact-js","19":"component---src-pages-experienceqs-js","20":"component---src-pages-gallery-js","21":"component---src-pages-index-js","22":"component---src-pages-learnqs-js","23":"component---src-pages-news-js","24":"component---src-pages-post-js","25":"component---src-pages-qmanagement-js","26":"component---src-pages-scapital-js","27":"component---src-pages-speaking-js","28":"component---src-pages-training-js","29":"component---src-pages-twelveprinciples-js","30":"component---src-pages-videos-js","31":"component---src-pages-whatissq-js","32":"component---src-templates-book-template-js","35":"reactPlayerDailyMotion","36":"reactPlayerFacebook","37":"reactPlayerFilePlayer","38":"reactPlayerKaltura","39":"reactPlayerMixcloud","40":"reactPlayerMux","41":"reactPlayerPreview","42":"reactPlayerSoundCloud","43":"reactPlayerStreamable","44":"reactPlayerTwitch","45":"reactPlayerVidyard","46":"reactPlayerVimeo","47":"reactPlayerWistia","48":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"4a76c7fd599ee52b9cc7","1":"5de74820e95c55fac4e9","2":"cb8915fb929f70eece76","3":"16a84a22d681a6a032a1","4":"24f26e840931b46825c9","5":"cbe1aab8157df34022ac","6":"f869381a1a86ae88bd24","7":"54e33c63dbeeaa81030a","8":"62da95162b978fad9a74","10":"ccc8c59a27e20522cf44","12":"bf5330079af91650b96f","13":"311be43b4bf3800dab24","14":"2a405e0973ce31e524e1","15":"51f2e2a56fe638aaeb60","16":"2708f10abe3842e9f4f1","17":"3f29a50c35af996d9e24","18":"30748d0abfea93213ab5","19":"aa26b44fb991ab98993a","20":"9bf50d0a1ac46941938f","21":"5dfddf1b9cb261ab2342","22":"d88ebbb25697377e15cf","23":"6d79621f7d7262fe5d66","24":"f53e3516fea5a0113cab","25":"eaaa0ae4efb455b5113b","26":"70e3b79e18331b26e844","27":"615f818e30fa40acba94","28":"ece0dd3e2e3c83bcac66","29":"ed62a57ebe1c21da353a","30":"e602c45f7b229f03ff09","31":"87a82652e905d7f0969d","32":"f65bcd0a1bac2cba2bcb","35":"b9df65577a0b4687d40e","36":"3590a9ce805322b7b29a","37":"4b1edc1b91705274f6b5","38":"4763a2cf9cc5831efab7","39":"948ec79f9d7ef80daf72","40":"38c967236e237c469eed","41":"e7c0cbc822a959d2742a","42":"58d3f19bbbd63ccb430f","43":"9df74202fcf8d2377c75","44":"094273ebefbccabab87e","45":"d0a38a3753a4056f4cec","46":"7e6d4cc78c834bbc36ce","47":"3cdb8b65e629335d1365","48":"7e811f649a21040bbd7c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"5":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"6c3301841966121d31ad3c402bc9f3ef6743708e","2":"a9a7754c","3":"c8448dc6fc1b73ed4655efbb68909e3bece9f249","4":"862906f15f3a45f165700e3a493a94f3528a0196","5":"styles","6":"0d28399fbb6fd230bc338b1270c6c3ab5e783c73","7":"31a89dfe27eda9d85a878493d0bca4d19294b91e","8":"368aecf4240697ddeb2db28fc8549b6e0d88c98f","10":"1c8efbdd","12":"cb1608f2","13":"component---src-pages-404-js","14":"component---src-pages-about-js","15":"component---src-pages-admin-js","16":"component---src-pages-blogs-js","17":"component---src-pages-books-js","18":"component---src-pages-contact-js","19":"component---src-pages-experienceqs-js","20":"component---src-pages-gallery-js","21":"component---src-pages-index-js","22":"component---src-pages-learnqs-js","23":"component---src-pages-news-js","24":"component---src-pages-post-js","25":"component---src-pages-qmanagement-js","26":"component---src-pages-scapital-js","27":"component---src-pages-speaking-js","28":"component---src-pages-training-js","29":"component---src-pages-twelveprinciples-js","30":"component---src-pages-videos-js","31":"component---src-pages-whatissq-js","32":"component---src-templates-book-template-js","35":"reactPlayerDailyMotion","36":"reactPlayerFacebook","37":"reactPlayerFilePlayer","38":"reactPlayerKaltura","39":"reactPlayerMixcloud","40":"reactPlayerMux","41":"reactPlayerPreview","42":"reactPlayerSoundCloud","43":"reactPlayerStreamable","44":"reactPlayerTwitch","45":"reactPlayerVidyard","46":"reactPlayerVimeo","47":"reactPlayerWistia","48":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"58141beda3e994c0ae93","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
